import React from "react";

export const Features = (props) => {
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title" style={{marginBottom:"0px", marginTop:"80px"}}>
          <h2>Why Choose TechFief</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.title}-${i}`} className="col-6 col-md-3" style={{marginBottom:"40px"}}>
                <div className="icon-with-number">
                  <i className={d.icon} style={{color:"transparent"}}></i>
                  <p className="icon-number">{d.number}</p>
                </div>
                <h3>{d.title}</h3>
                <p>{d.text}</p>
              </div>
            ))
            : "Loading..."}
        </div>
      </div>
    </div>

  );
};
